import React from 'react'
import { ListGroup, Col, Container, Button } from 'react-bootstrap'
import { faPen, faTrash, faGripLines, faExclamationSquare } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './ListItem.module.scss'
import CommonToolTip from '../../../ui/tooltip/commonToolTip'
import { useTranslation } from 'react-i18next'

interface IListItem {
  id?: number
  name?: string
  dragDrop: boolean
  onEdit: any
  onDelete: any
  disabled?: boolean
  contentCount?: any
}

const ListItem: React.FC<IListItem> = ({ id, name, dragDrop, onDelete, onEdit, disabled = false, contentCount = -1 }) => {
  const { t } = useTranslation()

  const noContent = () => {
    return (
      <CommonToolTip text={t('administration.lessons.noContentToolTip')} position={'right'}>
        <FontAwesomeIcon size={'xs'} icon={faExclamationSquare} />
      </CommonToolTip>
    )
  }

  return (
    <ListGroup.Item className={`${styles.listItem} ${dragDrop ? styles.draggable : ''}`}>
      <Container className={'d-flex py-1'}>
        <Col xs={1} className={`px-0 ${styles.dragIcon}`}>
          {dragDrop && <FontAwesomeIcon icon={faGripLines} />}
        </Col>
        <Col xs={6} md={10} className="pl-0">
          <p className={styles.name}>
            {name} {contentCount === 0 && !dragDrop && noContent()}
          </p>
        </Col>
        <Col className={'d-flex justify-content-end py-0'}>
          <Button className={`ml-2`} onClick={() => onEdit(id)} disabled={disabled}>
            <FontAwesomeIcon size={'xs'} icon={faPen} />
          </Button>
          <Button className={`ml-2`} onClick={() => onDelete(id, 'hardcoredType:)')} disabled={disabled}>
            <FontAwesomeIcon size={'xs'} icon={faTrash} />
          </Button>
        </Col>
      </Container>
    </ListGroup.Item>
  )
}

export default ListItem
